module.exports = __webpack_public_path__ + "static/media/testmonial.5a13f5c4.png";